import { type RouteLocationNamedRaw, type RouteLocationRaw, useRouter } from 'vue-router'

import { ROUTE_NAMES, type ROUTE_NAMES_GAME_GROUPS } from '@/router/constants'
import type { CategoryType } from '@/types'

const TYPE_GAME_GROUP_TO_PAGE_NAME: Record<CategoryType, ROUTE_NAMES_GAME_GROUPS> = {
    tag: ROUTE_NAMES.TAG,
    series: ROUTE_NAMES.SERIES,
    category: ROUTE_NAMES.CATEGORY,
    developer: ROUTE_NAMES.DEVELOPER,
    collection: ROUTE_NAMES.COLLECTION,
}

export function useUrl() {
    function getCategoryRoute({ hru, type }: { hru: string; type: CategoryType }): RouteLocationNamedRaw {
        return { name: TYPE_GAME_GROUP_TO_PAGE_NAME[type], params: { hru } }
    }

    return { getCategoryRoute }
}

export const useGetExternalUrl = () => {
    const router = useRouter()
    return (to: RouteLocationRaw) => {
        let { href } = router.resolve(to)
        // we have a HashHistory in PWA, so when building a url for external link or iFrame, we need to remove the hash
        if (href.startsWith('#')) {
            href = href.slice(1)
        }
        return href
    }
}
